import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IReduxState } from "../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../util/apiClient";
import { IDroit, setFilterDroits, setDroits } from "../CreationDroit/Droit/droitSlice";
import { IModuleDroit } from "../CreationDroit/Module/moduleDroitSlice";

export default function VisualiserDroit(props: any) {
  const { data, deleteItem, setItem, handleEditDialogOpen } = props;

  const dispatch = useDispatch();
  const { filterdroits } = useSelector((state: IReduxState) => state.droits);



  //hooks
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const theme = useTheme();
  const lgDown = useMediaQuery(theme.breakpoints.down("lg"));




  return (
    <Box
      sx={{ flexGrow: 1 }}
      style={{
        height: "60vh",
        overflow: "auto",
        marginTop: lgDown ? 50 : 0,
        paddingRight: 10,
      }}
    >
      <List dense={true}>
        {filterdroits.map((item: any, index: any) => {
          return (
            <div key={index}>
              <ListItem
                secondaryAction={
                  <Chip label={item.id} color="primary" variant="outlined" />
                }
              >
                <ListItemButton selected={selectedIndex === index}>
                  <ListItemText
                    onClick={(event) => console.log("aaaaaa")}
                    primary={item.libelle}
                    secondary={item.descriptionDroit}
                  />
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
    </Box>
  );
}
